import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import Hidden from "@material-ui/core/Hidden";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Quote from "components/Quote/Quote.jsx";
import Fact from "components/Fact/Fact.jsx";

import quoteFactStyle from "assets/jss/material-kit-react/components/quoteFactStyle.jsx";

class QuoteFact extends React.Component {
  render() {
    const {
      classes,
      quote,
      facts
    } = this.props;

    function BottomFacts({...props}) {
      const {
        facts
      } = props;

        return (facts.map((fact, index) => {
          return(
            <GridItem xs={12} sm={12 / facts.length} md={12}>
              <Fact plain fact={fact} />
            </GridItem>
          )}))

      // if (facts) {
      //   return facts.map((fact, index) => {
      //     if (index % 2 === 0) {
      //     return(
      //       <Hidden smDown>
      //       <GridItem xs={12} sm={12 / facts.length} md={12}>
      //         <Fact plain fact={fact} />
      //       </GridItem>
      //       </Hidden>
      //   )} else {
      //     return (
      //       <GridItem xs={12} sm={12 / facts.length} md={12}>
      //         <Fact plain fact={fact} />
      //       </GridItem>   
      //     )}
      //   })
      // } else {
      //   return null;
      // }
    }

    return (
      <GridContainer className={classes.quoteFact} justify="space-around" alignItems="center">
{/*        { facts && facts[0] ? 
          <Hidden mdUp>
             <GridItem xs={12} sm={12 / facts.length} md={12}>
            <Fact plain fact={facts[0]} />
          </GridItem>
        </Hidden>
        : ""}*/}
        {quote ? 
        <GridItem xs={12} md={4}>
          <Quote quote={quote}/>
        </GridItem>
        : ""}
        <GridItem xs={12} md={7}>
          <GridContainer>
            <BottomFacts facts={facts} />
          </GridContainer>
        </GridItem>
      </GridContainer>
    )
  }
}

QuoteFact.defaultProps = {
  facts: []
}

export default withStyles(quoteFactStyle)(QuoteFact);